module.exports = __webpack_public_path__ + "media/v2/components/FAQsPage/shared/FAQItem/icons/ico_arrow_right-dca1ff198388289bbe542f747c4fae5f.svg";